let itemsData = [{
  "sku_id": 1000271,
  "title": "蓝牙电子钥匙",
  "sub_title": "按键，蓝牙通信，APP授权，上报开锁记录",
  "ali_image": require('@/assets/img/item/902befd5f32a8caf4ca79b55d39ee25a.jpg'),
  "model": 'CG-MN-KEY01',
  "ali_images": [
    {'image':require('@/assets/img/products/blekey/key2/blekey1.jpg')},
    {'image':require('@/assets/img/products/blekey/key2/blekey2.jpg')},
    {'image':require('@/assets/img/products/blekey/key2/blekey3.jpg')},
    {'image':require('@/assets/img/products/blekey/key2/ble-mn-key-dem.png')},
//  {'image':require('@/assets/img/products/blekey/key2/keyDemesion.png')},
  ],
  'tech':[  
    '蓝牙芯片开发，通过APP连接网络',
    '超低功耗蓝牙芯片开发，待机电流小于15uA',
    '内置3.7V可充电锂电池，容量800mAH。充电接口TYPE-C',
    '语音提示功能。如“开锁次数为零”，“开锁成功”，“不在有效期”等',
    '开锁数据双重加密，随机变化',
    'OTA升级钥匙固件',
  ]
  ,'pdf_url':'BLE-MN-KEY01.pdf'
},{
  "sku_id": 1000299,
  "title": "蓝牙电子钥匙",
  "sub_title": "按键，蓝牙通信，APP授权，上报开锁记录",
  "ali_image": "http://image.smartisanos.cn/resource/ae40a16324658c192c7361d829f603bd.jpg",
  "model": 'CG-BG-KEY01',
  "ali_images": [
//  {'image':require('@/assets/img/products/blekey/key1/blekey-1.gif')},
    {'image':require('@/assets/img/products/blekey/key1/blekey-1.png')},
//  {'image':require('@/assets/img/products/blekey/key1/blekey-1.gif')},
    {'image':require('@/assets/img/products/blekey/key1/ble-bg-key-dem.png')},
    {'image':require('@/assets/img/products/blekey/key1/keyDemesion.png')},
  ],
  'tech':[
    '蓝牙芯片开发，通过APP连接网络',
    '超低功耗蓝牙芯片开发，待机电流小于15uA',
    '内置3.7V可充电锂电池，容量800mAH。充电接口专用',
    '蜂鸣器提示功能',
    '开锁数据双重加密，随机变化'
  ]
  ,'pdf_url':'BLE-BG-KEY01.pdf'
}]

export default itemsData



// WEBPACK FOOTER //
// ./src/lib/bleKeysDetailData.js